import React, { useContext } from 'react';
import { applicationContext } from 'helpers/services';
import { NavBar, Footer } from 'components';
import { makeStyles } from '@material-ui/core';


interface IProps {
    children: React.ReactNode
}

const useStyles = makeStyles(theme => ({
    content: {
        marginBottom: theme.spacing(5)
    }
}))

let PrivateLayout = ({ children }: IProps) => {
    let classes = useStyles();

    let appService = useContext(applicationContext);

    return (
        <>
            {appService.isLoading === false &&
                <div className={classes.content}>
                    <NavBar />
                    {children}
                    <Footer />
                </div>
            }
        </>
    )
}

export default PrivateLayout;